import { PAGE_POSITIONS } from 'types';
import type { CapiPlp } from 'types/capi/plp';
import { PlpModule } from 'types/capi/plp';

import usePageData from '~/hooks/usePageData';
import HeaderCarousel, { Variant } from '~/modules/HeaderCarousel';

function ModuleSection({
  sectionModules,
  position,
  variant
}: {
  position: PAGE_POSITIONS;
  sectionModules: PlpModule[] | undefined;
  variant: Variant;
}) {
  return sectionModules?.map((m) => {
    switch (m.type) {
      case 'HEADER_CAROUSEL':
        return (
          <HeaderCarousel
            variant={variant}
            analytics={{ id: 'PLP_CAROUSEL', position }}
            module={m}
          />
        );
    }
  });
}

export function TopModuleSection() {
  const { top_section_modules } = usePageData<CapiPlp>();

  return (
    <ModuleSection
      variant="small-lg-font"
      position="PLP Top Modules"
      sectionModules={top_section_modules}
    />
  );
}

export function MidModuleSection() {
  const { mid_section_modules } = usePageData<CapiPlp>();

  return (
    <div className="col-span-full">
      <ModuleSection
        variant="small-md-font"
        position="PLP Mid Modules"
        sectionModules={mid_section_modules}
      />
    </div>
  );
}
